import { GridFilter } from './gridTypes';

export const OPERATORS: Record<string, { label: string; types: string[] }> = {
    'contains':   { label: 'contém',           types: ['string', 'text'] },
    'startsWith': { label: 'inicia com',        types: ['string', 'text'] },
    'endsWith':   { label: 'termina com',       types: ['string', 'text'] },
    'eq':         { label: 'igual',             types: ['string', 'number', 'list', 'boolean'] },
    'neq':        { label: 'diferente',         types: ['string', 'number', 'list'] },
    'gt':         { label: 'maior que',         types: ['number', 'date', 'datetime'] },
    'gte':        { label: 'maior ou igual',    types: ['number', 'date', 'datetime'] },
    'lt':         { label: 'menor que',         types: ['number', 'date', 'datetime'] },
    'lte':        { label: 'menor ou igual',    types: ['number', 'date', 'datetime'] },
    'between':    { label: 'entre',             types: ['number', 'date', 'datetime'] },
    'in':         { label: 'contido em',        types: ['number'] },
    'filled':     { label: 'preenchido',        types: ['string', 'text', 'number'] },
};

export const BACKEND_OPERATOR_MAP: Record<string, string> = {
    'equals': 'eq',
    'notEqual': 'neq',
    'contains': 'contains',
    'notContains': 'neq',
    'startsWith': 'startsWith',
    'endsWith': 'endsWith',
    'greaterThan': 'gt',
    'greaterThanOrEqual': 'gte',
    'lessThan': 'lt',
    'lessThanOrEqual': 'lte',
    'between': 'between',
    'in': 'in',
    'filled': 'filled',
};

export const STORAGE_KEY_PREFIX = 'grid_state_';

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '';

export const ROW_HEIGHT = 28;
export const HEADER_HEIGHT = 33;
export const SAFETY_MARGIN = 0;

export const convertBackendInitialFilter = (initialFilterList: Record<string, any>): GridFilter[] => {
    if (!initialFilterList) return [];
    return Object.entries(initialFilterList).map(([name, config]) => ({
        name,
        operator: BACKEND_OPERATOR_MAP[config.type] || 'eq',
        value: config.filter ?? '',
        value2: config.filterTo ?? undefined,
    }));
};
